/**
 * PD-16859 — in voice, the chat bubble shows the written reply ("J00458",
 * "$12,654.51") while the audio is made from a spoken form of it ("J zero
 * zero four five eight", "twelve thousand…"). Text-to-speech reports how far
 * playback has got in the SPOKEN text; this maps that position onto the
 * written text, so the bubble reveals and cuts the written words.
 *
 * The mapping is proportional and then moved forward to the end of a word,
 * so a reveal or a cut never stops inside a word or a number.
 */
export function writtenPositionForSpoken(
	written: string,
	spokenLength: number,
	spokenIndex: number,
): number {
	if (written === '' || spokenLength <= 0 || spokenIndex <= 0) {
		return 0;
	}
	if (spokenIndex >= spokenLength) {
		return written.length;
	}
	const share = spokenIndex / spokenLength;
	let position = Math.round(written.length * share);
	while (position < written.length && /\S/.test(written.charAt(position))) {
		position += 1;
	}
	return Math.min(position, written.length);
}
